{
  "name": "frontend",
  "version": "0.1.51",
  "private": true,
  "dependencies": {
    "@ant-design/icons": "4.8.3",
    "@googlemaps/react-wrapper": "1.2.0",
    "@livekit/components-react": "2.9.24",
    "@livekit/components-styles": "1.2.0",
    "@livekit/krisp-noise-filter": "0.4.0",
    "@nandorojo/swr-firestore": "^0.16.0",
    "@tinymce/tinymce-react": "6.3.0",
    "@types/googlemaps": "^3.43.3",
    "antd": "4.24.16",
    "caniuse-lite": "1.0.30001806",
    "dayjs": "1.11.21",
    "docx": "^6.0.3",
    "file-saver": "^2.0.5",
    "firebase": "8.10.1",
    "formik": "2.4.9",
    "formik-antd": "^2.0.5",
    "livekit-client": "2.22.3",
    "phone": "^2.4.21",
    "react": "18.3.1",
    "react-device-detect": "2.2.3",
    "react-div-100vh": "^0.6.0",
    "react-dnd": "^14.0.2",
    "react-dnd-html5-backend": "^14.0.0",
    "react-dom": "18.3.1",
    "react-input-color": "^4.0.0",
    "react-intl": "5.25.1",
    "react-is": "^19.1.0",
    "react-router-dom": "5.3.4",
    "react-signature-canvas": "^1.0.3",
    "react-to-print": "^2.12.6",
    "react-use": "17.6.1",
    "recharts": "2.5.0",
    "styled-components": "5.3.11",
    "tinymce": "8.8.2",
    "tslib": "^2.6.2",
    "typescript": "5.9.3",
    "uuid": "^8.3.2",
    "xlsx": "0.18.5",
    "yup": "^0.32.9"
  },
  "scripts": {
    "start": "vite --host 0.0.0.0 --port 3000 --mode development",
    "lint": "eslint 'src/**/*.{js,ts,tsx}' --no-error-on-unmatched-pattern",
    "type": "tsc --noEmit",
    "test": "vitest run --passWithNoTests",
    "test:watch": "vitest",
    "audit-check": "check-audit --yarn",
    "audit-resolve": "resolve-audit --yarn",
    "build-dev": "rm -rf build && vite build --mode development",
    "build-preprod": "rm -rf build && vite build --mode preprod",
    "build-prod": "rm -rf build && vite build --mode prod"
  },
  "devDependencies": {
    "@playwright/test": "1.32.0",
    "@types/dom-mediacapture-record": "1.0.22",
    "@types/file-saver": "^2.0.3",
    "@types/node": "^15.6.1",
    "@types/phone": "^2.4.1",
    "@types/react": "18.3.26",
    "@types/react-dom": "18.3.7",
    "@types/react-helmet": "^6.1.1",
    "@types/react-router-dom": "^5.1.7",
    "@types/react-signature-canvas": "^1.0.1",
    "@types/styled-components": "^5.1.12",
    "@types/uuid": "^8.3.0",
    "@typescript-eslint/eslint-plugin": "8.46.2",
    "@typescript-eslint/parser": "8.46.2",
    "@vitejs/plugin-react": "^6.0.3",
    "env-cmd": "^10.1.0",
    "eslint": "8.57.1",
    "eslint-config-prettier": "^8.3.0",
    "eslint-plugin-prettier": "^3.4.0",
    "eslint-plugin-react": "^7.23.2",
    "eslint-plugin-react-hooks": "^4.2.0",
    "eslint-plugin-risxss": "^2.1.0",
    "jsdom": "^29.1.1",
    "npm-audit-resolver": "^2.3.0",
    "prettier": "^2.3.0",
    "ts-toolbelt": "^9.6.0",
    "vite": "^8.1.5",
    "vitest": "^4.1.10"
  },
  "resolutions": {
    "@babel/core": "7.29.0",
    "less": "4.1.3",
    "minimatch": "3.1.2",
    "@types/react": "18.3.26",
    "@types/react-dom": "18.3.7",
    "@types/babel__traverse": "7.14.2",
    "@types/minimatch": "3.0.5",
    "@types/lodash": "4.14.177",
    "dayjs": "1.11.21"
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  },
  "engines": {
    "node": ">=22.12.0 <23"
  }
}
